import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OriginStory() {
  return <section className="py-14 md:py-32 bg-charcoal relative" data-id="element-232">
      <div className="max-w-4xl mx-auto px-6" data-id="element-233">
        <FadeIn data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-8 md:mb-12 text-center" data-id="element-235">
            Historia de Origen
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-offwhite-dim leading-relaxed bg-charcoal-dark p-8 md:p-12 rounded-sm border border-charcoal-light" data-id="element-236">
          <FadeIn delay={0.1} data-id="element-237">
            <p data-id="element-238">Fui atleta toda mi vida.</p>
            <p data-id="element-239">
              Rendimiento era mi mundo. Resultados eran mi brújula. Y desde
              afuera se veía bien.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-240">
            <p data-id="element-241">
              Pero por dentro había algo que no cerraba. Una sensación constante
              de que algo faltaba. De que por más que hiciera, no llegaba a ese
              lugar de paz que buscaba.
            </p>
            <p data-id="element-242">No era el trabajo. No era la familia. No era la salud.</p>
            <p className="text-amber font-medium" data-id="element-243">
              Era que yo mismo estaba desalineado.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-244">
            <p data-id="element-245">Mi cuerpo iba para un lado y mi alma para otro.</p>
            <p data-id="element-246">
              Entrenaba fuerte pero dormía mal. Buscaba propósito pero vivía en
              modo reactivo. Quería estar presente en casa, pero llegaba vacío.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-247">
            <p data-id="element-248">Hasta que entendí algo que lo cambió todo:</p>
            <blockquote className="border-l-4 border-sand pl-6 py-2 my-8 text-xl font-heading font-bold text-offwhite" data-id="element-249">
              El problema no era lo que hacía. Era la coherencia entre lo que
              pensaba, sentía y hacía.
            </blockquote>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-250">
            <p data-id="element-251">
              Cuando empecé a trabajar las 2 cosas al mismo tiempo (cuerpo +
              alma), algo se acomodó.
            </p>
            <p data-id="element-252">
              La energía se estabilizó. El ruido mental bajó. Las relaciones
              mejoraron.
            </p>
            <p className="mt-6 text-xl text-offwhite font-medium" data-id="element-253">
              Y lo más importante:{' '}
              <span className="text-sand" data-id="element-254">me reconocí.</span>
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-255">
            <p data-id="element-256">
              Esa sensación de <em data-id="element-257">"estoy volviendo a mí"</em>… eso fue el
              cambio real.
            </p>
            <p data-id="element-258">
              RESET es el primer paso de ese proceso. El mismo que aplico yo. El
              mismo que aplico con las personas que acompaño.
            </p>
            <p className="mt-8 text-2xl font-heading font-bold text-amber text-center" data-id="element-259">
              7 días para probar que podés volver a vos.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}